import React from 'react'

function Link({ text, href, className, title, children }) {
  return (
      <a href={href} className={`text-sm text-green-900 ${className}`} title={title} target='_blank' rel='nofollow'>{text || children}</a>
  )
}

export default Link